// @flow

export const SCHEME_DEFAULT: 'default' = 'default';
export const SCHEME_DEFAULT_LIGHT: 'default_light' = 'default_light';
export const SCHEME_WHITE: 'white' = 'white';
export const SCHEME_LIGHT: 'light' = 'light';
export const SCHEME_DARK: 'dark' = 'dark';
export const SCHEME_PRIMARY: 'primary' = 'primary';
export const SCHEME_SECONDARY: 'secondary' = 'secondary';
export const SCHEME_TERTIARY: 'tertiary' = 'tertiary';

export const BORDER_DEFAULT: 'default' = 'default';
export const BORDER_FILL: 'fill' = 'fill';
export const BORDER_BORDER: 'border' = 'border';
export const BORDER_SHADOW: 'shadow' = 'shadow';

// Legacy constants
export const BORDER_HERO: 'hero' = 'hero';
export const BORDER_OUTLINE: 'outline' = 'outline';
export const BORDER_NONE: 'none' = 'none';

export default null;
